import { useEffect } from 'react';

/**
 * 公開頁的瀏覽器分頁標題 —— R316
 * -----------------------------------------------------------------------------
 * app 內頁共用 `index.html` 的單一 title 就夠了(都在殼裡、有側邊欄指示位置),但
 * 官網 / 條款 / 免責這三頁是**對外**的:分頁標題會出現在書籤、分享連結與搜尋結果裡,
 * 三頁共用同一個 app 標題等於對外只有一個名字。標題文字走 i18n(`*.docTitle`)。
 * R364:index.html 的 title 改為「HAi Creative」對齊 GCP OAuth 同意畫面的應用程式
 * 名稱;官網 docTitle 由文案稿的草稿式「官網首頁」改為帶定位句(owner 2026-09-21 拍板)。
 *
 * ⚠️ **離開時要還原**:不還原的話從官網點進 app,分頁會一直停在「HAi Creative 免責聲明」。
 * 這裡記的是**掛載當下**的 title(= index.html 的預設值),而不是寫死字串 —— 寫死就等於
 * 又多一份 app 名稱要同步。
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
